import { useContext } from "react"
import { useMutation } from "react-apollo"

import { SessionContext } from "contexts/session"

import { queryOptions } from "utils/helper"

import DEACTIVATE_USER from "../../graphql/UserManagement/mutations/deactivateUser"

const useDeactivateUserMutation = options => {
  const { user } = useContext(SessionContext)

  return useMutation(DEACTIVATE_USER, {
    ...queryOptions(user, true),
    ...options,
    refetchQueries: ['FindOneUser'],
  });
}

export default useDeactivateUserMutation
